'use client';
import React from 'react';
import Lich from './components/Lich';
import Sidebar from '@/components/Sidebar';

const LichPage = (props) => {
  const { rightBanners, linkPages, websiteCode } = props;

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="border-gray-100 container bg-white">
        <div className="container block md:flex ">
          <div className="w-full md:w-3/4 pr-4">
            <Lich {...props} />
          </div>
          <div className="w-full md:w-1/4">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LichPage;
